import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import RequestCardCompact from "./RequestCardCompact";
import "../../style/RequestCardCompact.css";

// responsive grid of request cards with empty state
function RequestCardGrid({ requests, darkMode, onCardClick, emptyMessage }) {
  const { t } = useTranslation();

  if (!requests || requests.length === 0) {
    return (
      <div className={`req-grid__empty ${darkMode ? "dark" : "light"}`}>
        <p>{emptyMessage || t("No requests yet")}</p>
      </div>
    );
  }

  return (
    <div className="req-grid">
      {requests.map((request) => (
        <RequestCardCompact
          key={request.id}
          request={request}
          darkMode={darkMode}
          onClick={onCardClick}
        />
      ))}
    </div>
  );
}

RequestCardGrid.propTypes = {
  requests: PropTypes.array.isRequired,
  darkMode: PropTypes.bool,
  onCardClick: PropTypes.func,
  emptyMessage: PropTypes.string,
};

export default RequestCardGrid;
